import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { allCallMode } from 'config';
import { DishTheme } from 'config/themes';
import { Earthlink, Windstream } from 'config/providers';

export const DishIFramed: MultiProviderConfig = {
  name: 'DishIFramed',
  micrositeCode: 'DishIFrame',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: 'https://www.dish.com/internet/qualification-tool/',
  title: 'DISH Shop For Internet',
  fallbackPhoneNumber: '855-554-2339',
  fallbackLeadModePhoneNumber: '855-554-2339',
  defaultCheckoutType: CheckoutType.CALL_MODE,
  defaultTheme: DishTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'DishIFrame',
  noOffersRetry: 2,
  getCheckoutType: allCallMode,
  //TVI-1925: Only show Earthlink and Windstream for Dish online
  providers: [Earthlink, Windstream],
  iFrameConfig: {
    hideHeaderAndFooter: true,
  },
};
